export const CELL_SIZE = 25; // box dimension
export const FLOOR_HEIGHT = 10; // base layer height
export const GROUND_DEFAULT_COLOR = '#fefefe';
export const FLOOR_DEFAULT_COLOR = '#dedede';
export const FLOOR_PLACEABLE_NFT = '#CCC';
export const DEFAULT_FLOOR_NUMBER = 1;

export const NFT_TEXTURE_BELOW_BLACKOUT = 0.01; // below search blackout
export const SELECTION_BKACKOUT_OFFSET = 0.02; // search blackout level
export const NFT_COLOR_ABOVE_BLACKOUT = 0.04; // above search blackout
export const NFT_TEXTURE_ABOVE_BLACKOUT = 0.05; // above search blackout

export const NFT_IMAGE_SIZE_PX = 256;

export const INVALID_NFT_PLACEMENT_COLOR = 0xff0000;
export const NFT_SELECTION_COLOR = 0xffffff;

export const FALLBACK_TEXTURE = [
  'fallback_0.png',
  'fallback_1.png',
  'fallback_2.png',
];

export const BASE_API_ENDPOINT = {
  dev: 'https://nft-dev.sulake.com/api/rooms',
  staging: 'https://nft-staging.sulake.com/api/rooms',
  prod: 'https://collectibles.habbo.com/api/rooms',
};

export const BASE_SCANNER_ENDPOINT = {
  dev: 'https://sepolia.etherscan.io',
  staging: 'https://etherscan.io',
  prod: 'https://etherscan.io',
};
